// src/context/EmployeeContext.tsx

import React, { createContext, useContext, useState, ReactNode } from "react";

// Define types for employee data
interface EmployeeDetail {
  firstName: string | null;
  email: string;
  takess: boolean;
  notification: boolean;
  screenshotTime: number;
  screenshotMinMinutes?: number;
  screenshotMaxMinutes?: number;
  idleTimeoutMinutes?: number;
  projectId: string;
}

// Define context type
interface EmployeeContextType {
  employees: EmployeeDetail[];
  setEmployees: (employees: EmployeeDetail[]) => void;
}

const EmployeeContext = createContext<EmployeeContextType | undefined>(
  undefined
);

interface EmployeeProviderProps {
  children: ReactNode;
}

// Create a provider component to wrap your app
export const EmployeeProvider: React.FC<EmployeeProviderProps> = ({
  children,
}) => {
  const [employees, setEmployees] = useState<EmployeeDetail[]>([]);

  return (
    <EmployeeContext.Provider value={{ employees, setEmployees }}>
      {children}
    </EmployeeContext.Provider>
  );
};

// Create a custom hook to use the employee context
export const useEmployee = (): EmployeeContextType => {
  const context = useContext(EmployeeContext);
  if (!context) {
    throw new Error("useEmployee must be used within an EmployeeProvider");
  }
  return context;
};
